<template>
  <div class="drawer">
    <el-drawer
      size="1500px"
      title="设置员工月目标"
      :visible.sync="drawerStatus"
      @close="handleClose"
    >
      <div style="padding-bottom: 40px; height: 100%; overflow: scroll">
        <el-row class="row">
          <el-col :span="24">
            <span class="label" style="vertical-align: middle">所选月份：</span>
            <span class="value" style="width: 656px">
              {{ $public.FTime(pkMonth, "YYYY-MM") }}
            </span>
          </el-col>
        </el-row>
        <el-row class="row">
          <el-col :span="6" style="display: flex">
            <span class="label">门店：</span>
            <el-select v-model="shopId" placeholder="请选择门店">
              <el-option
                v-for="item in myShopList"
                :key="item.shop_id"
                :label="item.shop_name"
                :value="item.shop_id"
              >
              </el-option>
            </el-select>

            <!-- <el-select v-model="shopId" placeholder="请选择门店">
              <el-option
                v-for="item in shopList"
                :key="item.shop_name"
                :label="item.shop_name"
                :value="item.shop_id"
              >
              </el-option>
            </el-select> -->
          </el-col>
          <el-col :span="4" style="display: flex">
            <span class="label">岗位：</span>
            <el-select v-model="postId" placeholder="选择岗位">
              <el-option
                v-for="item in [
                  { name: '销售', value: '5' },
                  { name: '医生', value: '1' },
                  { name: '美容师', value: '3' },
                ]"
                :key="item.name"
                :label="item.name"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="6" style="margin-left: 20px">
            <el-button type="warning" icon="el-icon-search" @click="search"
              >查询修改</el-button
            >
            <el-button type="warning" plain @click="rest">重置</el-button>
          </el-col>
        </el-row>

        <div class="boxView">
          <el-row class="row">
            <el-col :span="24">
              <span class="label">员工业绩目标：</span>
              <span class="value">
                <div class="table">
                  <div class="tableRow">
                    <div class="cell">员工名称</div>
                    <div class="cell">门店</div>
                    <div class="cell">岗位</div>
                    <!-- <div class="cell">上月业绩</div> -->
                    <div class="cell">本月目标</div>
                    <div
                      class="cell"
                      v-for="(item, index) in week_setting_list"
                      :key="index"
                    >
                      第{{ index + 1 }}周
                    </div>
                    <!-- <div class="cell">是否设置</div> -->
                  </div>

                  <div
                    class="tableRow"
                    v-for="(shop, index) in datas.staff_setting_list"
                    :key="index"
                  >
                    <div class="cell">
                      {{ shop.staff_info && shop.staff_info.staff_name }}
                    </div>
                    <div class="cell">
                      {{
                        $public.getShopNameById(
                          shop.staff_info.shop_info.shop_id
                        )
                      }}店
                    </div>
                    <div class="cell">
                      {{ staffList[shop.staff_info.staff_type] }}
                    </div>
                    <!-- <div class="cell">
                      {{ shop.last_month_target }}
                    </div> -->
                    <div class="cell">{{ shop.month_target }}</div>
                    <div
                      class="cell"
                      v-for="(item, indexA) in shop.week_target_list"
                      :key="indexA"
                    >
                      {{ item }}
                    </div>
                    <!-- <div class="cell">
                      {{ shop.isSet }}
                    </div> -->
                  </div>
                </div>
              </span>
            </el-col>
          </el-row>
        </div>
        <div style="height: 40px; width: 100%"></div>
      </div>
    </el-drawer>
    <!-- 设置员工目标 -->
    <div v-if="staffSetParams_state">
      <staffSetParams
        :datas="datas"
        :staffArr="staffArr"
        :shopId="shopId"
        :postId="postId"
        @submit="submit_staffSetParams"
      ></staffSetParams>
    </div>
  </div>
</template>

<script>
import shopList from "../../../util/shopList";
import staffSetParams from "./staffSetParams.vue";
export default {
  components: { staffSetParams },
  data() {
    return {
      staffArr: [],
      targetObj: null,
      week_setting_list: [],
      staffSetParams_state: false,
      // 月份
      pkMonth: sessionStorage.getItem("pkMonth"),
      staffList: ["", "医生", "医助", "美容师", "美助", "销售"],
      postId: "",
      shopId: this.$store.state.shopId,
      shopList: shopList,
      drawerStatus: true,

      datas: { staff_setting_list: [] },
      selectedList: [],
      shop_setting_list: [],
      staff_setting_list: [],
      // dialog
      dialog_state: false,
      dialog_radio: 1,
      dialog_money: "",
      dialog_rate: "",
    };
  },
  computed: {
    myShopList() {
      return this.$store.state.myShopList;
    },
  },
  props: {},
  mounted() {
    console.log(this.pkMonth, "pkMonth");
    this.getSetting();
  },
  methods: {
    submit_staffSetParams() {
      this.staffSetParams_state = false;
      this.shopId = "";
      this.postId = "";
      this.getSetting();
    },
    rest() {
      this.shopId = "";
      this.postId = "";
      this.datas.staff_setting_list = this.staff_setting_list;
    },
    search() {
      if (this.$public.isNull(this.shopId)) {
        this.$message({
          message: "请选择门店",
          type: "error",
        });
        return;
      }
      if (this.$public.isNull(this.postId)) {
        this.$message({
          message: "需要确认岗位才能进行查询修改",
          type: "error",
        });
        return;
      }
      this.staffArr = this.staff_setting_list.filter((item) => {
        return (
          this.shopId == item.staff_info.shop_info.shop_id &&
          this.postId == item.staff_info.staff_type
        );
      });
      // 打开设置页面
      this.staffSetParams_state = true;
      // this.$emit("submit", { type: "close" });
    },

    handleClose() {
      this.$emit("submit", { type: "close" });
    },

    getSetting() {
      let loading = this.$loading();
      let params = {
        month_info: this.$public.FTime(this.pkMonth, "YYYY-MM"),
      };
      this.$http
        .get(
          process.env.VUE_APP_Url9 +
            "api/ShopPerformancePKService/GetShopPerformanceSettingViewModel",
          params
        )
        .then((res) => {
          loading.close();
          this.drawerStatus = true;
          if (res.code == 0) {
            console.log(res, "数据-----");
            let datas = res.data;
            this.shop_setting_list = res.data.shop_setting_list;
            this.week_setting_list = res.data.week_setting_list;
            for (let i = 0; i < datas.staff_setting_list.length; i++) {
              const isNull = datas.staff_setting_list[i].week_target_list.every(
                (item) => item === 0
              );
              if (isNull) {
                this.$set(datas.staff_setting_list[i], "isSet", false);
              } else {
                this.$set(datas.staff_setting_list[i], "isSet", true);
              }
            }
            console.log(datas, "datas");
            this.staff_setting_list = datas.staff_setting_list;
            this.datas = datas;
          }
        });
    },
  },
};
</script>

<style scoped lang="scss">
.drawer {
  width: 0;
  padding: 0 0 0 0;
  ::v-deep.el-drawer {
    .el-drawer__header {
      margin-bottom: 10px;
    }

    .el-drawer__body {
      overflow-y: auto;
      padding-bottom: 30px;
      height: calc(100% - 75px);
    }
    .boxView {
      .row {
        padding: 20px 20px 0;
        float: none;
        font-size: 20px;
        .label {
          display: inline-block;
          width: 150px;
          text-align: right;
          font-size: 14px;
          color: $fontColor;
          vertical-align: top;
        }
        .value {
          display: inline-block;
          font-size: 14px;
          color: $fontColor;
          .table {
            border: 1px solid #e7e7e7;
            border-right: 0;
            border-bottom: 0;
            width: 1400px;
            margin-left: 10px;
            .tableRow {
              display: flex;
              border-bottom: 1px solid #e7e7e7;
              .cell {
                border-right: 1px solid #e7e7e7;
                height: 50px;
                width: 100%;
                text-align: center;
                padding: 8px 0;
                box-sizing: border-box;
                line-height: 32px;
              }
            }
          }
        }
      }
    }
    .row {
      padding: 30px 10px 0;
      float: none;
      font-size: 20px;
      .label {
        line-height: 40px;
        display: inline-block;
        width: 120px;
        text-align: right;
        font-size: 14px;
        color: $fontColor;
        vertical-align: top;
      }
      .value {
        display: inline-block;
        font-size: 14px;
        color: $fontColor;
        .table {
          border: 1px solid #e7e7e7;
          border-right: 0;
          border-bottom: 0;
          width: 90%;
          margin-left: 10px;
          .tableRow {
            display: flex;
            border-bottom: 1px solid #e7e7e7;
            .cell {
              border-right: 1px solid #e7e7e7;
              height: 50px;
              width: 100%;
              text-align: center;
              padding: 8px 0;
              box-sizing: border-box;
              line-height: 32px;
              &:last-child {
                width: 200%;
              }
            }
          }
        }
      }
    }
  }
}
.btnBox {
  width: 100%;
  font-size: 14px;
  color: #fff;
  line-height: 40px;
  display: flex;
  position: absolute;
  bottom: 0;
  z-index: 10;
  .btnItem {
    text-align: center;
    width: 100%;
    background-color: #d6d6d6;
    cursor: pointer;
    &.submit {
      background-color: $mainColor;
    }
  }
}
// dialog
.dialogCon {
  .line {
    display: flex;
    padding: 10px 0;
    .label {
      font-size: 14px;
      color: $fontColor;
      vertical-align: middle;
    }
    .value {
    }
  }
}
</style>
